/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: execFetchField
// ====================================================

export interface execFetchField {
  execFetchField: string;
}

export interface execFetchFieldVariables {
  value: string;
  categoryFieldConfigId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: BrandInformationQuery
// ====================================================

export interface BrandInformationQuery_brandInformation {
  __typename: 'BrandInformation';
  brandColor: string;
  instanceLogo: string | null;
  providerLogo: string | null;
  name: string;
}

export interface BrandInformationQuery {
  brandInformation: BrandInformationQuery_brandInformation | null;
}

export interface BrandInformationQueryVariables {
  categoryId?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CategoryBrandInformationQuery
// ====================================================

export interface CategoryBrandInformationQuery_categoryBrandInformation_category {
  __typename: 'Category';
  id: string;
}

export interface CategoryBrandInformationQuery_categoryBrandInformation {
  __typename: 'CategoryBrandInformation';
  id: string;
  brandColor: string | null;
  instanceLogo: string | null;
  category: CategoryBrandInformationQuery_categoryBrandInformation_category | null;
}

export interface CategoryBrandInformationQuery {
  categoryBrandInformation: CategoryBrandInformationQuery_categoryBrandInformation | null;
}

export interface CategoryBrandInformationQueryVariables {
  categoryId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CategoriesQuery
// ====================================================

export interface CategoriesQuery_categories {
  __typename: 'Category';
  id: string;
  label: string;
  description: string | null;
  key: string;
  externalKey: string | null;
  selfService: boolean;
}

export interface CategoriesQuery {
  categories: CategoriesQuery_categories[];
}

export interface CategoriesQueryVariables {
  active?: boolean | null;
  selfService?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: LanguagesQuery
// ====================================================

export interface LanguagesQuery_languages {
  __typename: 'Language';
  id: string;
  label: string;
  locale: string;
  default: boolean;
}

export interface LanguagesQuery {
  languages: LanguagesQuery_languages[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: MetaQuery
// ====================================================

export interface MetaQuery_context {
  __typename: 'Context';
  meta: string;
}

export interface MetaQuery {
  context: MetaQuery_context;
}

export interface MetaQueryVariables {
  contextId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: TranslationsQuery
// ====================================================

export interface TranslationsQuery_staticTranslations {
  __typename: 'StaticTranslation';
  translations: string;
}

export interface TranslationsQuery {
  staticTranslations: TranslationsQuery_staticTranslations;
}

export interface TranslationsQueryVariables {
  language: string;
  moduleId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FeatureFlagQuery
// ====================================================

export interface FeatureFlagQuery_featureFlags_featureFlagSettings {
  __typename: 'FeatureFlagSetting';
  id: string;
  key: string;
  description: string | null;
  label: string;
  required: boolean;
  type: FeatureFlagSettingType;
  value: string;
}

export interface FeatureFlagQuery_featureFlags {
  __typename: 'FeatureFlag';
  id: number;
  enabled: boolean;
  key: string;
  description: string;
  label: string;
  userControllable: boolean;
  featureFlagSettings: FeatureFlagQuery_featureFlags_featureFlagSettings[];
}

export interface FeatureFlagQuery {
  featureFlags: FeatureFlagQuery_featureFlags[];
}

export interface FeatureFlagQueryVariables {
  userControllable?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FeatureFlagSetting
// ====================================================

export interface FeatureFlagSetting_featureFlagSetting {
  __typename: 'FeatureFlagSetting';
  key: string;
  value: string;
}

export interface FeatureFlagSetting {
  featureFlagSetting: FeatureFlagSetting_featureFlagSetting;
}

export interface FeatureFlagSettingVariables {
  featureFlagSettingKey: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateBrandInformation
// ====================================================

export interface UpdateBrandInformation_updateBrandInformation {
  __typename: 'BrandInformation';
  brandColor: string;
  instanceLogo: string | null;
  name: string;
  providerLogo: string | null;
}

export interface UpdateBrandInformation {
  updateBrandInformation: UpdateBrandInformation_updateBrandInformation;
}

export interface UpdateBrandInformationVariables {
  input: EditBrandInformationInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateCategoryBrandInformation
// ====================================================

export interface CreateCategoryBrandInformation_createCategoryBrandInformation_category {
  __typename: 'Category';
  id: string;
}

export interface CreateCategoryBrandInformation_createCategoryBrandInformation {
  __typename: 'CategoryBrandInformation';
  id: string;
  brandColor: string | null;
  instanceLogo: string | null;
  category: CreateCategoryBrandInformation_createCategoryBrandInformation_category | null;
}

export interface CreateCategoryBrandInformation {
  createCategoryBrandInformation: CreateCategoryBrandInformation_createCategoryBrandInformation;
}

export interface CreateCategoryBrandInformationVariables {
  input: CreateCategoryBrandInformationInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EditCategoryBrandInformation
// ====================================================

export interface EditCategoryBrandInformation_updateCategoryBrandInformation_category {
  __typename: 'Category';
  id: string;
}

export interface EditCategoryBrandInformation_updateCategoryBrandInformation {
  __typename: 'CategoryBrandInformation';
  id: string;
  brandColor: string | null;
  instanceLogo: string | null;
  category: EditCategoryBrandInformation_updateCategoryBrandInformation_category | null;
}

export interface EditCategoryBrandInformation {
  updateCategoryBrandInformation: EditCategoryBrandInformation_updateCategoryBrandInformation;
}

export interface EditCategoryBrandInformationVariables {
  input: EditCategoryBrandInformationInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteCategoryBrandInformation
// ====================================================

export interface DeleteCategoryBrandInformation_deleteCategoryBrandInformation {
  __typename: 'MutationResult';
  success: boolean;
}

export interface DeleteCategoryBrandInformation {
  deleteCategoryBrandInformation: DeleteCategoryBrandInformation_deleteCategoryBrandInformation;
}

export interface DeleteCategoryBrandInformationVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateOrderMutation
// ====================================================

export interface UpdateOrderMutation_updateCategoryOrder {
  __typename: 'MutationResult';
  success: boolean;
}

export interface UpdateOrderMutation {
  updateCategoryOrder: UpdateOrderMutation_updateCategoryOrder;
}

export interface UpdateOrderMutationVariables {
  input: UpdateCategoryOrderInput[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateCategory
// ====================================================

export interface CreateCategory_createCategory {
  __typename: 'Category';
  id: string;
}

export interface CreateCategory {
  createCategory: CreateCategory_createCategory;
}

export interface CreateCategoryVariables {
  input: CreateCategoryInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CopyCategory
// ====================================================

export interface CopyCategory_copyCategory {
  __typename: 'Category';
  id: string;
}

export interface CopyCategory {
  copyCategory: CopyCategory_copyCategory;
}

export interface CopyCategoryVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteCategory
// ====================================================

export interface DeleteCategory_deleteCategory {
  __typename: 'MutationResult';
  success: boolean;
}

export interface DeleteCategory {
  deleteCategory: DeleteCategory_deleteCategory;
}

export interface DeleteCategoryVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateLeadSegmentConfiguration
// ====================================================

export interface CreateLeadSegmentConfiguration_createLeadSegmentConfiguration {
  __typename: 'LeadSegmentConfiguration';
  id: string;
}

export interface CreateLeadSegmentConfiguration {
  createLeadSegmentConfiguration: CreateLeadSegmentConfiguration_createLeadSegmentConfiguration;
}

export interface CreateLeadSegmentConfigurationVariables {
  input: CreateLeadSegmentConfigurationInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddTranslation
// ====================================================

export interface AddTranslation_addTranslation {
  __typename: 'Translation';
  id: string;
}

export interface AddTranslation {
  addTranslation: AddTranslation_addTranslation;
}

export interface AddTranslationVariables {
  input: CreateTranslationInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateFieldOrder
// ====================================================

export interface UpdateFieldOrder_updateCategoryFieldConfigurationOrder {
  __typename: 'MutationResult';
  success: boolean;
}

export interface UpdateFieldOrder {
  updateCategoryFieldConfigurationOrder: UpdateFieldOrder_updateCategoryFieldConfigurationOrder;
}

export interface UpdateFieldOrderVariables {
  input: UpdateCategoryFieldConfigOrderInput[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateCategoryFieldConfiguration
// ====================================================

export interface CreateCategoryFieldConfiguration_createCategoryFieldConfiguration {
  __typename: 'CategoryFieldConfiguration';
  id: string;
}

export interface CreateCategoryFieldConfiguration {
  createCategoryFieldConfiguration: CreateCategoryFieldConfiguration_createCategoryFieldConfiguration;
}

export interface CreateCategoryFieldConfigurationVariables {
  input: CreateCategoryFieldConfigInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteCategoryFieldConfiguration
// ====================================================

export interface DeleteCategoryFieldConfiguration_deleteCategoryFieldConfiguration {
  __typename: 'MutationResult';
  success: boolean;
}

export interface DeleteCategoryFieldConfiguration {
  deleteCategoryFieldConfiguration: DeleteCategoryFieldConfiguration_deleteCategoryFieldConfiguration;
}

export interface DeleteCategoryFieldConfigurationVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateCategoryFieldConfiguration
// ====================================================

export interface UpdateCategoryFieldConfiguration_updateCategoryFieldConfiguration {
  __typename: 'CategoryFieldConfiguration';
  id: string;
}

export interface UpdateCategoryFieldConfiguration {
  updateCategoryFieldConfiguration: UpdateCategoryFieldConfiguration_updateCategoryFieldConfiguration;
}

export interface UpdateCategoryFieldConfigurationVariables {
  input: UpdateCategoryFieldConfigInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpsertFetchFieldMapping
// ====================================================

export interface UpsertFetchFieldMapping_upsertFetchFieldMapping {
  __typename: 'FetchFieldMapping';
  id: string;
  mapping: string;
}

export interface UpsertFetchFieldMapping {
  upsertFetchFieldMapping: UpsertFetchFieldMapping_upsertFetchFieldMapping;
}

export interface UpsertFetchFieldMappingVariables {
  input: UpsertFetchFieldMappingInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AllCategoriesQuery
// ====================================================

export interface AllCategoriesQuery_categories_leadSegmentConfiguration {
  __typename: 'LeadSegmentConfiguration';
  id: string;
  default: string;
  prefix: string;
  suffix: string;
}

export interface AllCategoriesQuery_categories_translations {
  __typename: 'Translation';
  id: string;
  value: string;
}

export interface AllCategoriesQuery_categories {
  __typename: 'Category';
  id: string;
  active: boolean;
  key: string;
  externalKey: string | null;
  label: string;
  order: number;
  description: string | null;
  selfService: boolean;
  leadSegmentConfiguration: AllCategoriesQuery_categories_leadSegmentConfiguration;
  translations: AllCategoriesQuery_categories_translations[];
}

export interface AllCategoriesQuery {
  categories: AllCategoriesQuery_categories[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CategoryFieldsQuery
// ====================================================

export interface CategoryFieldsQuery_category_leadSegmentConfiguration {
  __typename: 'LeadSegmentConfiguration';
  id: string;
  default: string;
  prefix: string;
  suffix: string;
}

export interface CategoryFieldsQuery_category_translations {
  __typename: 'Translation';
  id: string;
  value: string;
}

export interface CategoryFieldsQuery_category_fields_fetchField {
  __typename: 'FetchField';
  id: string;
  serviceEndpoint: string;
  serviceMethod: HttpMethod;
}

export interface CategoryFieldsQuery_category_fields_categoryFieldConfiguration {
  __typename: 'CategoryFieldConfiguration';
  id: string;
  defaultValue: string | null;
  categoryId: string;
  order: number;
  required: boolean;
  visible: boolean;
}

export interface CategoryFieldsQuery_category_fields_options_translations_language {
  __typename: 'Language';
  label: string;
  locale: string;
}

export interface CategoryFieldsQuery_category_fields_options_translations {
  __typename: 'Translation';
  id: string;
  value: string;
  language: CategoryFieldsQuery_category_fields_options_translations_language | null;
}

export interface CategoryFieldsQuery_category_fields_options {
  __typename: 'Option';
  id: string;
  value: string;
  order: number;
  label: string | null;
  translations:
    | CategoryFieldsQuery_category_fields_options_translations[]
    | null;
}

export interface CategoryFieldsQuery_category_fields_validators_translations_language {
  __typename: 'Language';
  label: string;
  locale: string;
}

export interface CategoryFieldsQuery_category_fields_validators_translations {
  __typename: 'Translation';
  id: string;
  value: string;
  language: CategoryFieldsQuery_category_fields_validators_translations_language | null;
}

export interface CategoryFieldsQuery_category_fields_validators {
  __typename: 'Validator';
  id: string;
  regex: string;
  errorMessage: string | null;
  translations: CategoryFieldsQuery_category_fields_validators_translations[];
}

export interface CategoryFieldsQuery_category_fields_translations_language {
  __typename: 'Language';
  label: string;
  locale: string;
}

export interface CategoryFieldsQuery_category_fields_translations {
  __typename: 'Translation';
  id: string;
  language: CategoryFieldsQuery_category_fields_translations_language | null;
  value: string;
}

export interface CategoryFieldsQuery_category_fields {
  __typename: 'CategoryField';
  id: string;
  defaultValue: string | null;
  defaultValueBehaviour: DefaultValueBehaviour;
  defaultValueLevel: DefaultValueLevel;
  key: string;
  section: Section;
  icon: string | null;
  order: number | null;
  label: string;
  dataType: DataType;
  fetchField: CategoryFieldsQuery_category_fields_fetchField | null;
  categoryFieldConfiguration: CategoryFieldsQuery_category_fields_categoryFieldConfiguration[];
  options: CategoryFieldsQuery_category_fields_options[] | null;
  validators: CategoryFieldsQuery_category_fields_validators[] | null;
  translations: CategoryFieldsQuery_category_fields_translations[];
}

export interface CategoryFieldsQuery_category {
  __typename: 'Category';
  id: string;
  key: string;
  externalKey: string | null;
  label: string;
  order: number;
  description: string | null;
  active: boolean;
  selfService: boolean;
  leadSegmentConfiguration: CategoryFieldsQuery_category_leadSegmentConfiguration;
  translations: CategoryFieldsQuery_category_translations[];
  fields: CategoryFieldsQuery_category_fields[];
}

export interface CategoryFieldsQuery {
  category: CategoryFieldsQuery_category;
}

export interface CategoryFieldsQueryVariables {
  categoryId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateCategoryMutation
// ====================================================

export interface UpdateCategoryMutation_updateCategory {
  __typename: 'Category';
  id: string;
}

export interface UpdateCategoryMutation {
  updateCategory: UpdateCategoryMutation_updateCategory;
}

export interface UpdateCategoryMutationVariables {
  input: UpdateCategoryInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AllFieldsQuery
// ====================================================

export interface AllFieldsQuery_fields {
  __typename: 'Field';
  id: string;
  defaultValue: string | null;
  key: string;
  section: Section;
  icon: string | null;
  inputType: InputType;
  skedifyCustomerAttribute: string | null;
  usedForQualification: boolean;
}

export interface AllFieldsQuery {
  fields: AllFieldsQuery_fields[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FetchFieldMapping
// ====================================================

export interface FetchFieldMapping_fetchFieldMapping {
  __typename: 'FetchFieldMapping';
  id: string;
  mapping: string;
}

export interface FetchFieldMapping {
  fetchFieldMapping: FetchFieldMapping_fetchFieldMapping | null;
}

export interface FetchFieldMappingVariables {
  categoryFieldConfigurationId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateField
// ====================================================

export interface CreateField_createField {
  __typename: 'Field';
  id: string;
}

export interface CreateField {
  createField: CreateField_createField;
}

export interface CreateFieldVariables {
  input: CreateFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateField
// ====================================================

export interface UpdateField_updateFields {
  __typename: 'Field';
  id: string;
}

export interface UpdateField {
  updateFields: UpdateField_updateFields[];
}

export interface UpdateFieldVariables {
  input: UpdateFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteField
// ====================================================

export interface DeleteField_deleteField {
  __typename: 'MutationResult';
  success: boolean;
}

export interface DeleteField {
  deleteField: DeleteField_deleteField;
}

export interface DeleteFieldVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateTranslationsMutation
// ====================================================

export interface UpdateTranslationsMutation_updateTranslations {
  __typename: 'Translation';
  id: string;
}

export interface UpdateTranslationsMutation {
  updateTranslations: UpdateTranslationsMutation_updateTranslations[];
}

export interface UpdateTranslationsMutationVariables {
  input: UpdateTranslationInput[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddTranslationMutation
// ====================================================

export interface AddTranslationMutation_addTranslation {
  __typename: 'Translation';
  id: string;
}

export interface AddTranslationMutation {
  addTranslation: AddTranslationMutation_addTranslation;
}

export interface AddTranslationMutationVariables {
  input: CreateTranslationInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddOption
// ====================================================

export interface AddOption_addOption {
  __typename: 'Option';
  id: string;
}

export interface AddOption {
  addOption: AddOption_addOption;
}

export interface AddOptionVariables {
  input: AddOptionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateOption
// ====================================================

export interface UpdateOption_updateOption {
  __typename: 'Option';
  id: string;
}

export interface UpdateOption {
  updateOption: UpdateOption_updateOption;
}

export interface UpdateOptionVariables {
  input: UpdateOptionFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteOption
// ====================================================

export interface DeleteOption_deleteOption {
  __typename: 'MutationResult';
  success: boolean;
}

export interface DeleteOption {
  deleteOption: DeleteOption_deleteOption;
}

export interface DeleteOptionVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddValidator
// ====================================================

export interface AddValidator_addValidator {
  __typename: 'Validator';
  id: string;
}

export interface AddValidator {
  addValidator: AddValidator_addValidator;
}

export interface AddValidatorVariables {
  input: AddValidatorInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateValidator
// ====================================================

export interface UpdateValidator_updateValidator {
  __typename: 'Validator';
  id: string;
}

export interface UpdateValidator {
  updateValidator: UpdateValidator_updateValidator;
}

export interface UpdateValidatorVariables {
  input: UpdateValidatorInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteValidator
// ====================================================

export interface DeleteValidator_deleteValidator {
  __typename: 'MutationResult';
  success: boolean;
}

export interface DeleteValidator {
  deleteValidator: DeleteValidator_deleteValidator;
}

export interface DeleteValidatorVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpsertFetchField
// ====================================================

export interface UpsertFetchField_upsertFetchField {
  __typename: 'FetchField';
  id: string;
}

export interface UpsertFetchField {
  upsertFetchField: UpsertFetchField_upsertFetchField;
}

export interface UpsertFetchFieldVariables {
  input: UpsertFetchFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FieldsQuery
// ====================================================

export interface FieldsQuery_fields_categories {
  __typename: 'Category';
  key: string;
}

export interface FieldsQuery_fields_translations_language {
  __typename: 'Language';
  label: string;
  locale: string;
}

export interface FieldsQuery_fields_translations {
  __typename: 'Translation';
  id: string;
  value: string;
  language: FieldsQuery_fields_translations_language | null;
}

export interface FieldsQuery_fields {
  __typename: 'Field';
  categories: FieldsQuery_fields_categories[];
  id: string;
  defaultValue: string | null;
  defaultValueBehaviour: DefaultValueBehaviour;
  defaultValueLevel: DefaultValueLevel;
  key: string;
  section: Section;
  icon: string | null;
  dataType: DataType;
  inputType: InputType;
  skedifyCustomerAttribute: string | null;
  usedForQualification: boolean;
  translations: FieldsQuery_fields_translations[];
}

export interface FieldsQuery {
  fields: FieldsQuery_fields[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FieldQuery
// ====================================================

export interface FieldQuery_field_categories {
  __typename: 'Category';
  key: string;
}

export interface FieldQuery_field_categoryFieldConfiguration_category {
  __typename: 'Category';
  id: string;
}

export interface FieldQuery_field_categoryFieldConfiguration {
  __typename: 'CategoryFieldConfiguration';
  id: string;
  defaultValue: string | null;
  category: FieldQuery_field_categoryFieldConfiguration_category;
  order: number;
  required: boolean;
  visible: boolean;
}

export interface FieldQuery_field_fetchField {
  __typename: 'FetchField';
  id: string;
  postBody: string | null;
  serviceEndpoint: string;
  serviceMethod: HttpMethod;
}

export interface FieldQuery_field_options_translations_language {
  __typename: 'Language';
  label: string;
  locale: string;
}

export interface FieldQuery_field_options_translations {
  __typename: 'Translation';
  id: string;
  value: string;
  language: FieldQuery_field_options_translations_language | null;
}

export interface FieldQuery_field_options {
  __typename: 'Option';
  id: string;
  value: string;
  order: number;
  label: string | null;
  translations: FieldQuery_field_options_translations[] | null;
}

export interface FieldQuery_field_translations_language {
  __typename: 'Language';
  label: string;
  locale: string;
}

export interface FieldQuery_field_translations {
  __typename: 'Translation';
  id: string;
  value: string;
  language: FieldQuery_field_translations_language | null;
}

export interface FieldQuery_field_validators_translations_language {
  __typename: 'Language';
  label: string;
  locale: string;
}

export interface FieldQuery_field_validators_translations {
  __typename: 'Translation';
  id: string;
  value: string;
  language: FieldQuery_field_validators_translations_language | null;
}

export interface FieldQuery_field_validators {
  __typename: 'Validator';
  id: string;
  regex: string;
  errorMessage: string | null;
  translations: FieldQuery_field_validators_translations[];
}

export interface FieldQuery_field {
  __typename: 'Field';
  categories: FieldQuery_field_categories[];
  categoryFieldConfiguration: FieldQuery_field_categoryFieldConfiguration[];
  id: string;
  defaultValue: string | null;
  defaultValueBehaviour: DefaultValueBehaviour;
  defaultValueLevel: DefaultValueLevel;
  key: string;
  section: Section;
  icon: string | null;
  dataType: DataType;
  inputType: InputType;
  fetchField: FieldQuery_field_fetchField | null;
  options: FieldQuery_field_options[] | null;
  skedifyCustomerAttribute: string | null;
  usedForQualification: boolean;
  translations: FieldQuery_field_translations[];
  validators: FieldQuery_field_validators[] | null;
}

export interface FieldQuery {
  field: FieldQuery_field;
}

export interface FieldQueryVariables {
  fieldId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateLeadSegmentConfiguration
// ====================================================

export interface UpdateLeadSegmentConfiguration_updateLeadSegmentConfiguration {
  __typename: 'LeadSegmentConfiguration';
  id: string;
}

export interface UpdateLeadSegmentConfiguration {
  updateLeadSegmentConfiguration: UpdateLeadSegmentConfiguration_updateLeadSegmentConfiguration;
}

export interface UpdateLeadSegmentConfigurationVariables {
  input: UpdateLeadSegmentConfigurationInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ClearCache
// ====================================================

export interface ClearCache_clearCache {
  __typename: 'MutationResult';
  success: boolean;
}

export interface ClearCache {
  clearCache: ClearCache_clearCache;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateFeatureFlag
// ====================================================

export interface UpdateFeatureFlag_updateFeatureFlag {
  __typename: 'FeatureFlag';
  id: number;
  enabled: boolean;
}

export interface UpdateFeatureFlag {
  updateFeatureFlag: UpdateFeatureFlag_updateFeatureFlag;
}

export interface UpdateFeatureFlagVariables {
  input: UpdateFeatureFlagInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateFeatureFlags
// ====================================================

export interface UpdateFeatureFlags_updateFeatureFlags {
  __typename: 'MutationResult';
  success: boolean;
}

export interface UpdateFeatureFlags {
  updateFeatureFlags: UpdateFeatureFlags_updateFeatureFlags;
}

export interface UpdateFeatureFlagsVariables {
  input: UpdateFeatureFlagInput[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateUser
// ====================================================

export interface CreateUser_createUser_roles {
  __typename: 'Role';
  id: string;
  name: string;
}

export interface CreateUser_createUser_allowedCategories {
  __typename: 'Category';
  id: string;
  label: string;
}

export interface CreateUser_createUser {
  __typename: 'User';
  id: string;
  email: string;
  externalId: string | null;
  firstName: string;
  lastName: string;
  roles: CreateUser_createUser_roles[];
  allowedCategories: CreateUser_createUser_allowedCategories[];
}

export interface CreateUser {
  createUser: CreateUser_createUser;
}

export interface CreateUserVariables {
  input: CreateUserInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateUser
// ====================================================

export interface UpdateUser_updateUser_roles {
  __typename: 'Role';
  id: string;
  name: string;
}

export interface UpdateUser_updateUser_allowedCategories {
  __typename: 'Category';
  id: string;
  label: string;
}

export interface UpdateUser_updateUser {
  __typename: 'User';
  id: string;
  email: string;
  externalId: string | null;
  firstName: string;
  lastName: string;
  roles: UpdateUser_updateUser_roles[];
  allowedCategories: UpdateUser_updateUser_allowedCategories[];
}

export interface UpdateUser {
  updateUser: UpdateUser_updateUser;
}

export interface UpdateUserVariables {
  input: UpdateUserInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteUser
// ====================================================

export interface DeleteUser_deleteUser {
  __typename: 'MutationResult';
  success: boolean;
}

export interface DeleteUser {
  deleteUser: DeleteUser_deleteUser;
}

export interface DeleteUserVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: UserListQuery
// ====================================================

export interface UserListQuery_users_roles {
  __typename: 'Role';
  id: string;
  name: string;
}

export interface UserListQuery_users_allowedCategories {
  __typename: 'Category';
  id: string;
  label: string;
}

export interface UserListQuery_users {
  __typename: 'User';
  id: string;
  email: string;
  externalId: string | null;
  firstName: string;
  lastName: string;
  roles: UserListQuery_users_roles[];
  allowedCategories: UserListQuery_users_allowedCategories[];
}

export interface UserListQuery {
  users: UserListQuery_users[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RoleListQuery
// ====================================================

export interface RoleListQuery_roles {
  __typename: 'Role';
  id: string;
  name: string;
}

export interface RoleListQuery {
  roles: RoleListQuery_roles[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateContext
// ====================================================

export interface UpdateContext_updateContext_leadSegment {
  __typename: 'LeadSegment';
  id: string;
}

export interface UpdateContext_updateContext {
  __typename: 'Context';
  contextId: string;
  leadSegment: UpdateContext_updateContext_leadSegment | null;
}

export interface UpdateContext {
  updateContext: UpdateContext_updateContext;
}

export interface UpdateContextVariables {
  input: UpdateContextInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FieldsListQuery
// ====================================================

export interface FieldsListQuery_category_fields_conditionalActions_actions {
  __typename: 'Action';
  type: string;
  payload: string;
}

export interface FieldsListQuery_category_fields_conditionalActions {
  __typename: 'ConditionalAction';
  condition: string;
  actions: FieldsListQuery_category_fields_conditionalActions_actions[];
}

export interface FieldsListQuery_category_fields_fieldGroup {
  __typename: 'FieldGroup';
  id: string;
  icon: string;
  label: string;
}

export interface FieldsListQuery_category_fields_validators {
  __typename: 'Validator';
  regex: string;
  errorMessage: string | null;
}

export interface FieldsListQuery_category_fields_options {
  __typename: 'Option';
  label: string | null;
  value: string;
}

export interface FieldsListQuery_category_fields {
  __typename: 'CategoryField';
  id: string;
  categoryFieldConfigurationId: string;
  usedForQualification: boolean;
  requiredForQualification: boolean;
  conditionalActions:
    | FieldsListQuery_category_fields_conditionalActions[]
    | null;
  section: Section;
  required: boolean | null;
  order: number | null;
  inputType: InputType;
  dataType: DataType;
  defaultValue: string | null;
  defaultValueBehaviour: DefaultValueBehaviour;
  visible: boolean | null;
  icon: string | null;
  key: string;
  fieldGroup: FieldsListQuery_category_fields_fieldGroup | null;
  label: string;
  validators: FieldsListQuery_category_fields_validators[] | null;
  options: FieldsListQuery_category_fields_options[] | null;
}

export interface FieldsListQuery_category {
  __typename: 'Category';
  key: string;
  fields: FieldsListQuery_category_fields[];
}

export interface FieldsListQuery {
  category: FieldsListQuery_category;
}

export interface FieldsListQueryVariables {
  categoryId: string;
  active?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AttributesQuery
// ====================================================

export interface AttributesQuery_context_attributes_field {
  __typename: 'Field';
  id: string;
  key: string;
  dataType: DataType;
  skedifyCustomerAttribute: string | null;
  defaultValueBehaviour: DefaultValueBehaviour;
}

export interface AttributesQuery_context_attributes {
  __typename: 'Attribute';
  value: string;
  field: AttributesQuery_context_attributes_field;
}

export interface AttributesQuery_context_filters_location {
  __typename: 'LocationFilter';
  countryCode: string | null;
  postalCode: string | null;
}

export interface AttributesQuery_context_filters {
  __typename: 'Filter';
  contacts: string[] | null;
  location: AttributesQuery_context_filters_location | null;
}

export interface AttributesQuery_context_category {
  __typename: 'Category';
  id: string;
}

export interface AttributesQuery_context {
  __typename: 'Context';
  contextId: string;
  attributes: AttributesQuery_context_attributes[];
  filters: AttributesQuery_context_filters[] | null;
  category: AttributesQuery_context_category | null;
}

export interface AttributesQuery {
  context: AttributesQuery_context;
}

export interface AttributesQueryVariables {
  contextId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: LeadSegmentQuery
// ====================================================

export interface LeadSegmentQuery_leadSegment {
  __typename: 'LeadSegment';
  id: string;
}

export interface LeadSegmentQuery {
  leadSegment: LeadSegmentQuery_leadSegment | null;
}

export interface LeadSegmentQueryVariables {
  contextId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateCallback
// ====================================================

export interface CreateCallback_createCallback {
  __typename: 'CallbackResponse';
  callbackId: string;
}

export interface CreateCallback {
  createCallback: CreateCallback_createCallback;
}

export interface CreateCallbackVariables {
  input: CreateCallbackInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateAppointment
// ====================================================

export interface CreateAppointment_createAppointment {
  __typename: 'AppointmentResponse';
  appointmentId: string;
  contactId: string;
  officeId: string;
}

export interface CreateAppointment {
  createAppointment: CreateAppointment_createAppointment;
}

export interface CreateAppointmentVariables {
  input: CreateAppointmentInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CallbackQuery
// ====================================================

export interface CallbackQuery_context_callback_buttons {
  __typename: 'CallbackButton';
  label: string;
  value: string;
}

export interface CallbackQuery_context_callback {
  __typename: 'CallbackConfig';
  enabled: boolean;
  buttons: CallbackQuery_context_callback_buttons[];
}

export interface CallbackQuery_context {
  __typename: 'Context';
  callback: CallbackQuery_context_callback | null;
}

export interface CallbackQuery {
  context: CallbackQuery_context;
}

export interface CallbackQueryVariables {
  contextId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ListingsQuery
// ====================================================

export interface ListingsQuery_listings_location_location {
  __typename: 'GeoObject';
  lat: number;
  lng: number;
}

export interface ListingsQuery_listings_location {
  __typename: 'ListingLocation';
  full_address: string;
  street: string;
  postal_code: string;
  city: string;
  country_short: string;
  location: ListingsQuery_listings_location_location;
  timezone: string;
}

export interface ListingsQuery_listings {
  __typename: 'Listing';
  id: string;
  uuid: string;
  description: string | null;
  location: ListingsQuery_listings_location | null;
  title: string;
}

export interface ListingsQuery {
  listings: ListingsQuery_listings[];
}

export interface ListingsQueryVariables {
  contextId?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SubjectsQuery
// ====================================================

export interface SubjectsQuery_subjects_category {
  __typename: 'SubjectCategory';
  name: string;
  order: number;
}

export interface SubjectsQuery_subjects {
  __typename: 'Subject';
  id: string;
  description: string | null;
  title: string;
  order: number;
  category: SubjectsQuery_subjects_category;
}

export interface SubjectsQuery {
  subjects: SubjectsQuery_subjects[];
}

export interface SubjectsQueryVariables {
  listingId?: string | null;
  leadSegmentId?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: MeetingTypesQuery
// ====================================================

export interface MeetingTypesQuery_meetingTypes {
  __typename: 'MeetingType';
  defaultAddressKey: string | null;
  title: string;
  label: MeetingTypeLabel;
  maxConcurrentTimetables: number;
}

export interface MeetingTypesQuery {
  meetingTypes: MeetingTypesQuery_meetingTypes[];
}

export interface MeetingTypesQueryVariables {
  subjectId: string;
  listingId?: string | null;
  leadSegmentId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: OfficesQuery
// ====================================================

export interface OfficesQuery_offices {
  __typename: 'Office';
  id: string;
  active: boolean;
  distance: number | null;
  virtual: boolean | null;
  timezone: string;
  location: string;
  title: string;
}

export interface OfficesQuery {
  offices: OfficesQuery_offices[];
}

export interface OfficesQueryVariables {
  coordinates?: GeoInput | null;
  location?: LocationInput | null;
  subjectId: string;
  listingId?: string | null;
  meetingType: MeetingTypeLabel;
  filters?: FilterInput[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ContactsQuery
// ====================================================

export interface ContactsQuery_contacts_contacts {
  __typename: 'Contact';
  id: string;
  fullName: string;
  firstName: string;
  lastName: string;
  position: string | null;
  profilePicture: string | null;
}

export interface ContactsQuery_contacts {
  __typename: 'ContactResponse';
  contacts: ContactsQuery_contacts_contacts[];
  total: number;
  currentPage: number;
  lastPage: number;
}

export interface ContactsQuery {
  contacts: ContactsQuery_contacts;
}

export interface ContactsQueryVariables {
  officeId: string;
  subjectId: string;
  listingId?: string | null;
  limit?: number | null;
  offset?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: Timetable
// ====================================================

export interface Timetable_timetable_warnings {
  __typename: 'Warning';
  code: number;
  message: string;
}

export interface Timetable_timetable_groups_rows_columns {
  __typename: 'Column';
  contacts: string[] | null;
  endDate: string | null;
  key: string;
  open: boolean;
  startDate: string | null;
}

export interface Timetable_timetable_groups_rows {
  __typename: 'Row';
  endDate: string;
  startDate: string;
  followsPreviousRow: boolean;
  columns: Timetable_timetable_groups_rows_columns[];
}

export interface Timetable_timetable_groups {
  __typename: 'Group';
  title: string;
  endTime: string;
  startTime: string;
  rows: Timetable_timetable_groups_rows[];
}

export interface Timetable_timetable {
  __typename: 'Timetable';
  columnAmount: number;
  endDate: any;
  startDate: any;
  warnings: Timetable_timetable_warnings[];
  groups: Timetable_timetable_groups[];
}

export interface Timetable {
  timetable: Timetable_timetable;
}

export interface TimetableVariables {
  timetableInput: TimetableInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CallbackDetail
// ====================================================

export interface CallbackDetail_callback_office {
  __typename: 'Office';
  title: string;
  location: string;
}

export interface CallbackDetail_callback_customer {
  __typename: 'SkedifyCustomer';
  firstName: string | null;
  lastName: string | null;
  phoneNumber: string | null;
  email: string | null;
}

export interface CallbackDetail_callback_subject {
  __typename: 'Subject';
  title: string;
  description: string | null;
}

export interface CallbackDetail_callback {
  __typename: 'Callback';
  office: CallbackDetail_callback_office | null;
  callbackTimeLabel: string;
  customer: CallbackDetail_callback_customer;
  max: number | null;
  metadata: string | null;
  min: number | null;
  notes: string | null;
  subject: CallbackDetail_callback_subject | null;
  updatedAt: string;
}

export interface CallbackDetail {
  callback: CallbackDetail_callback;
}

export interface CallbackDetailVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AppointmentDetail
// ====================================================

export interface AppointmentDetail_appointment_contact {
  __typename: 'Contact';
  fullName: string;
  firstName: string;
  lastName: string;
  position: string | null;
  profilePicture: string | null;
}

export interface AppointmentDetail_appointment_customer {
  __typename: 'SkedifyCustomer';
  email: string | null;
  firstName: string | null;
  lastName: string | null;
  phoneNumber: string | null;
  timezone: string | null;
}

export interface AppointmentDetail_appointment_office {
  __typename: 'Office';
  location: string;
  title: string;
  virtual: boolean | null;
}

export interface AppointmentDetail_appointment_subject {
  __typename: 'Subject';
  description: string | null;
  title: string;
}

export interface AppointmentDetail_appointment {
  __typename: 'Appointment';
  cancelUrl: string;
  contact: AppointmentDetail_appointment_contact | null;
  customer: AppointmentDetail_appointment_customer | null;
  editUrl: string;
  endDate: string;
  location: string | null;
  meetingType: MeetingTypeLabel;
  notes: string | null;
  office: AppointmentDetail_appointment_office;
  startDate: string;
  subject: AppointmentDetail_appointment_subject;
  videoUrl: string | null;
}

export interface AppointmentDetail {
  appointment: AppointmentDetail_appointment;
}

export interface AppointmentDetailVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AuthorizeFromContext
// ====================================================

export interface AuthorizeFromContext_authorizeFromContext {
  __typename: 'ContextAccessLogResponse';
  token: string;
}

export interface AuthorizeFromContext {
  authorizeFromContext: AuthorizeFromContext_authorizeFromContext;
}

export interface AuthorizeFromContextVariables {
  contextId: string;
  isSelfService?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateOwnUser
// ====================================================

export interface UpdateOwnUser_updateUser {
  __typename: 'User';
  id: string;
  email: string;
  firstName: string;
  lastName: string;
}

export interface UpdateOwnUser {
  updateUser: UpdateOwnUser_updateUser;
}

export interface UpdateOwnUserVariables {
  input: UpdateUserInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: UserQuery
// ====================================================

export interface UserQuery_user {
  __typename: 'User';
  id: string;
  firstName: string;
  lastName: string;
  email: string;
}

export interface UserQuery {
  user: UserQuery_user;
}

export interface UserQueryVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * Possible data types accepted by a Field
 */
export enum DataType {
  ADDRESS = 'ADDRESS',
  BOOLEAN = 'BOOLEAN',
  EMAIL = 'EMAIL',
  FETCH_FIELD = 'FETCH_FIELD',
  NUMBER = 'NUMBER',
  PHONE = 'PHONE',
  TEXT = 'TEXT',
  WEBSITE = 'WEBSITE',
}

/**
 * Behaviour of the Default value field
 */
export enum DefaultValueBehaviour {
  EDITABLE = 'EDITABLE',
  FIXED = 'FIXED',
}

/**
 * Level of the Default value field
 */
export enum DefaultValueLevel {
  CATEGORY = 'CATEGORY',
  FIELD = 'FIELD',
}

export enum FeatureFlagSettingType {
  LONG_TEXT = 'LONG_TEXT',
  NUMBER = 'NUMBER',
  TEXT = 'TEXT',
}

export enum HttpMethod {
  GET = 'GET',
  POST = 'POST',
}

/**
 * Input type the field should be rendered as
 */
export enum InputType {
  ADDRESS_PICKER = 'ADDRESS_PICKER',
  DROP_DOWN = 'DROP_DOWN',
  PHONE_NUMBER = 'PHONE_NUMBER',
  RADIO_BUTTONS = 'RADIO_BUTTONS',
  SWITCH = 'SWITCH',
  TEXT_AREA = 'TEXT_AREA',
  TEXT_FIELD = 'TEXT_FIELD',
}

/**
 * Different labels for MeetingTypes
 */
export enum MeetingTypeLabel {
  OFFICE = 'OFFICE',
  ON_LOCATION = 'ON_LOCATION',
  PHONE = 'PHONE',
  VIDEO = 'VIDEO',
}

/**
 * Form section of the Field
 */
export enum Section {
  FIELD = 'FIELD',
  QUESTION = 'QUESTION',
}

/**
 * Type of the target entity to whom the translation belongs.
 */
export enum TargetType {
  CATEGORY = 'CATEGORY',
  CATEGORY_FIELD_CONFIGURATION = 'CATEGORY_FIELD_CONFIGURATION',
  FEATURE_FLAG = 'FEATURE_FLAG',
  FIELD = 'FIELD',
  FIELD_GROUP = 'FIELD_GROUP',
  OPTION = 'OPTION',
  VALIDATOR = 'VALIDATOR',
}

export interface AddOptionInput {
  fieldId: string;
  order: number;
  translations: AddTranslationInput[];
  value: string;
}

export interface AddTranslationInput {
  language: number;
  property?: string | null;
  value: string;
}

export interface AddValidatorInput {
  fieldId: string;
  regex: string;
  translations: AddTranslationInput[];
}

export interface AdditionalParticipantsInput {
  email: string;
  firstName: string;
  lastName: string;
}

export interface AllowedCategoryInput {
  id: string;
}

export interface AnswerInput {
  questionId: string;
  value: string[];
}

export interface AttributeInput {
  key: string;
  value: string;
}

export interface CreateAppointmentInput {
  additionalParticipants?: AdditionalParticipantsInput[] | null;
  answers: AnswerInput[];
  contactId?: string | null;
  contextId: string;
  forced: boolean;
  listingUuid?: string | null;
  meetingType: MeetingTypeLabel;
  officeId: string;
  subjectId: string;
  timeSlots: TimeSlotInput[];
  usedAddress?: UsedAddressInput | null;
  usedAddressKey?: string | null;
  timezone?: string | null;
  notes?: string | null;
}

export interface CreateCallbackInput {
  contextId: string;
  callbackHours?: string | null;
  forced: boolean;
  notes?: string | null;
  timezone?: string | null;
}

export interface CreateCategoryBrandInformationInput {
  brandColor?: string | null;
  categoryId: string;
  instanceLogo?: string | null;
  pluginStyles?: string | null;
}

export interface CreateCategoryFieldConfigInput {
  categoryId: string;
  fieldId: string;
  defaultValue?: string | null;
  required: boolean;
  translations: AddTranslationInput[];
  visible: boolean;
}

export interface CreateCategoryInput {
  key: string;
  active?: boolean | null;
  externalKey?: string | null;
  leadSegmentConfiguration: CreateLeadSegmentConfigurationInput;
  order: number;
  selfService: boolean;
  translations?: AddTranslationInput[] | null;
}

export interface CreateFieldInput {
  dataType: DataType;
  defaultValue?: string | null;
  defaultValueBehaviour?: DefaultValueBehaviour | null;
  defaultValueLevel?: DefaultValueLevel | null;
  icon?: string | null;
  inputType: InputType;
  key: string;
  option?: CreateOptionFieldInput[] | null;
  section: Section;
  skedifyCustomerAttribute?: string | null;
  translations?: AddTranslationInput[] | null;
  usedForQualification: boolean;
  validators?: ValidatorInput[] | null;
}

export interface CreateLeadSegmentConfigurationInput {
  default: string;
  prefix: string;
  suffix: string;
}

export interface CreateOptionFieldInput {
  order: number;
  value: string;
}

export interface CreateTranslationInput {
  language: number;
  property?: string | null;
  targetId: string;
  targetType: TargetType;
  value: string;
}

export interface CreateUserInput {
  allowedCategories?: AllowedCategoryInput[] | null;
  email: string;
  externalId?: string | null;
  firstName: string;
  lastName: string;
  password: string;
  roles: RoleInput[];
}

export interface EditBrandInformationInput {
  brandColor?: string | null;
  instanceLogo?: string | null;
  name?: string | null;
  pluginStyles?: string | null;
  providerLogo?: string | null;
}

export interface EditCategoryBrandInformationInput {
  id: string;
  brandColor?: string | null;
  instanceLogo?: string | null;
  pluginStyles?: string | null;
}

export interface FeatureFlagSettingInput {
  id: string;
  value: string;
}

export interface FilterInput {
  contactExternalIds?: string[] | null;
  contacts?: string[] | null;
  location?: LocationFilterInput | null;
}

export interface GeoInput {
  lat: number;
  lng: number;
}

export interface LocationFilterInput {
  countryCode?: string | null;
  postalCode?: string | null;
}

export interface LocationInput {
  country?: string | null;
  postalCode?: string | null;
}

export interface RoleInput {
  id: string;
}

export interface TimeSlotInput {
  contacts: string[];
  end: string;
  start: string;
}

export interface TimetableInput {
  contacts?: string[] | null;
  contextId: string;
  coordinates?: GeoInput | null;
  listingId?: string | null;
  location?: LocationInput | null;
  endDate: any;
  meetingType: MeetingTypeLabel;
  officeId: string;
  startDate: any;
  subjectId: string;
  timezone: string;
}

export interface UpdateCategoryFieldConfigInput {
  id: string;
  defaultValue?: string | null;
  required?: boolean | null;
  translations?: UpdateTranslationInput[] | null;
  visible?: boolean | null;
}

export interface UpdateCategoryFieldConfigOrderInput {
  id: string;
  order: number;
}

export interface UpdateCategoryInput {
  id: string;
  active?: boolean | null;
  externalKey?: string | null;
  key?: string | null;
  leadSegmentConfiguration: UpdateLeadSegmentConfigurationInput;
  order?: number | null;
  selfService?: boolean | null;
  translations?: UpdateTranslationInput[] | null;
}

export interface UpdateCategoryOrderInput {
  id: string;
  order: number;
}

export interface UpdateContextInput {
  contextId?: string | null;
  data?: string | null;
  attributes: AttributeInput[];
}

export interface UpdateFeatureFlagInput {
  id: number;
  enabled: boolean;
  featureFlagSettings?: FeatureFlagSettingInput[] | null;
  translations?: UpdateTranslationInput[] | null;
}

export interface UpdateFieldInput {
  id: string;
  dataType?: DataType | null;
  defaultValue?: string | null;
  defaultValueBehaviour?: DefaultValueBehaviour | null;
  defaultValueLevel?: DefaultValueLevel | null;
  icon?: string | null;
  inputType?: InputType | null;
  key?: string | null;
  options?: UpdateOptionFieldInput[] | null;
  section?: Section | null;
  skedifyCustomerAttribute?: string | null;
  usedForQualification?: boolean | null;
  validators?: ValidatorInput[] | null;
}

export interface UpdateLeadSegmentConfigurationInput {
  id: string;
  default?: string | null;
  prefix?: string | null;
  suffix?: string | null;
}

export interface UpdateOptionFieldInput {
  id: string;
  order?: number | null;
  translations?: UpdateTranslationInput[] | null;
  value?: string | null;
}

export interface UpdateTranslationInput {
  id: string;
  language?: number | null;
  property?: string | null;
  value: string;
}

export interface UpdateUserInput {
  id: string;
  allowedCategories?: AllowedCategoryInput[] | null;
  email?: string | null;
  externalId?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  password?: string | null;
  roles?: RoleInput[] | null;
}

export interface UpdateValidatorInput {
  id: string;
  regex?: string | null;
  translations?: UpdateTranslationInput[] | null;
}

export interface UpsertFetchFieldInput {
  id?: string | null;
  fieldId: string;
  headers?: string | null;
  postBody?: string | null;
  serviceEndpoint: string;
  serviceMethod: HttpMethod;
}

export interface UpsertFetchFieldMappingInput {
  id?: string | null;
  categoryFieldConfigurationId: string;
  fetchFieldId: string;
  mapping: string;
}

export interface UsedAddressInput {
  city: string;
  countryCode: string;
  coordinates: GeoInput;
  houseNumber?: string | null;
  floorNumber?: string | null;
  postalCode: string;
  street: string;
  state?: string | null;
  unitNumber?: string | null;
}

export interface ValidatorInput {
  regex: string;
  translations?: UpdateTranslationInput[] | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
